export const EDMONTON_REGION_NEIGHBORHOODS = {
  'south-edmonton': [
    'Tamarack',
    'Laurel',
    'The Orchards At Ellerslie',
    'Pollard Meadows',
    'Ellerslie',
    'Summerside',
    'Walker',
    'Allard',
    'Cavanagh',
    'Desrochers Area',
    'Heritage Valley Town Centre Area',
    'Blackmud Creek',
    'Rutherford (Edmonton)',
  ],
  'southeast-edmonton': [
    'Silver Berry',
    'Wild Rose',
    'Maple Crest',
    'Maple Ridge (Edmonton)',
    'Aster',
    'Mill Woods Town Centre',
    'Lee Ridge',
    'Michaels Park',
    'Tipaskan',
    'Crawford Plains',
    'Larkspur',
    'Pollard Meadows',
  ],
  'southwest-edmonton': [
    'Windermere',
    'Keswick',
    'Ambleside',
    'Glenridding Heights',
    'Glenridding Ravine',
    'Chappelle Area',
    'Paisley',
    'Callaghan',
    'Magrath Heights',
    'Cameron Heights (Edmonton)',
    'Haddow',
    'Rio Terrace',
    'Wedgewood Heights',
  ],
} as const;

export type EdmontonRegionSlug = keyof typeof EDMONTON_REGION_NEIGHBORHOODS;

export function getEdmontonRegionNeighborhoods(region?: string | null): string[] | undefined {
  if (!region) return undefined;
  const key = region.toLowerCase() as EdmontonRegionSlug;
  const list = EDMONTON_REGION_NEIGHBORHOODS[key];
  return list ? [...list] : undefined;
}

export function getEdmontonRegionTitle(region?: string | null) {
  const key = region?.toLowerCase();
  switch (key) {
    case 'south-edmonton':
      return 'South Edmonton';
    case 'southeast-edmonton':
      return 'Southeast Edmonton';
    case 'southwest-edmonton':
      return 'Southwest Edmonton';
    default:
      return undefined;
  }
}
